import styled, { css } from 'styled-components';
import theme from '../../theme';

const Wrapper = styled.div`
  position: relative;
  ${(props) => props.isFocused && !props.readOnly && css`
    box-shadow: ${theme.shadows.primaryFocus};
  `}
`;

export default Wrapper;
